import { render, staticRenderFns } from "./IntelligentManufacturing.vue?vue&type=template&id=22def602&scoped=true&"
import script from "./IntelligentManufacturing.vue?vue&type=script&lang=js&"
export * from "./IntelligentManufacturing.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentManufacturing.vue?vue&type=style&index=0&id=22def602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22def602",
  null
  
)

export default component.exports